export default __webpack_public_path__ + "static/media/Logo.8f732197.png";